import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  Divider,
  Image,
  JustifyContent,
  Space,
  Text,
  TextAlign,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import eveningStandardPNG from '../assets/eveningstandard.png'
import eveningStandardWEBP from '../assets/eveningstandard.webp'
import goodFoodPNG from '../assets/goodfood.png'
import goodFoodWEBP from '../assets/goodfood.webp'
import independentPNG from '../assets/independent.png'
import independentWEBP from '../assets/independent.webp'
import telegraphPNG from '../assets/telegraph.png'
import telegraphWEBP from '../assets/telegraph.webp'

const LogoImage = withCitrusTheme(Image, () => ({
  mixBlendMode: 'multiply',
}))

export const CWCAsFeaturedInStrip = () => (
  <Box data-testid="as-featured-in-strip">
    <Divider color={Color.ColdGrey_200} />
    <Space size={[6, null, null, 10]} />
    <Text
      display={Display.Block}
      textAlign={TextAlign.Center}
      uppercase
      size={2}
      color={Color.ColdGrey_400}
    >
      As featured in
    </Text>
    <Space size={4} />
    <Box
      display={Display.Flex}
      wrap
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Center}
      gap={[6, null, null, 12]}
    >
      <LogoImage
        height={['72px', null, null, '98px']}
        width="auto"
        alt="Good Food"
        srcSet={goodFoodWEBP}
        src={goodFoodPNG}
      />
      <LogoImage
        height={['44px', null, null, '60px']}
        width="auto"
        alt="The Telegraph"
        srcSet={telegraphWEBP}
        src={telegraphPNG}
      />
      <LogoImage
        height={['28px', null, null, '38px']}
        width="auto"
        alt="The Independent"
        srcSet={independentWEBP}
        src={independentPNG}
      />
      <LogoImage
        height={['26px', null, null, '34px']}
        width="auto"
        alt="Evening Standard"
        srcSet={eveningStandardWEBP}
        src={eveningStandardPNG}
      />
    </Box>
  </Box>
)
